import { useQuery } from "@tanstack/react-query";
import { useStore } from "../../helpers";

export const useRepoTags = (projectid?: string) => {
  const { aiGentoolStore } = useStore();

  return useQuery({
    queryKey: ["tags", projectid],
    enabled: !!projectid,
    queryFn: async () => {
      return await aiGentoolStore.getRepoTags({
        projectid: parseInt(projectid!),
      });
    },
    select: (data) => {
      return data?.data?.tags?.map((tag) => {
        return { label: tag, value: tag };
      });
    },
  });
};
